(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerSubCategory', CustomerSubCategory);

    CustomerSubCategory.$inject = ['$resource'];

    function CustomerSubCategory ($resource) {
        var resourceUrl =  'api/customer-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
